module.exports = __webpack_public_path__ + "static/media/review2.4c7b9aec.svg";